import { SRM, CAR_OWNER_TYPE } from '../../../../../../../constant/constant.js'
import { carTypeSrmAdvanceConfig } from '../../../../../../../constant/advanceConfig.js'
import { vehicleRules } from '../formdataAndRules.js'

// 车型高级组件配置信息
export const paramsLength = {
    ...carTypeSrmAdvanceConfig,
    name: '车型',
    value: 'lengthNameCn',
    dialogWidth: '1150px',
    unfold: true,
    border: true,
    advanceConfig: [
        { prop: 'actualVechile', value: '车型名称' },
        { prop: 'cdegCode', value: '车型代码' },
        { prop: 'flyWingFlag', value: '是否飞翼车', placeholder: '请输入 是/否' },
    ],
    tableConfig: [
        { prop: 'cdegCode', value: '车型代码' },
        { prop: 'actualVechile', value: '实际车型' },
        { prop: 'vehicleBigType', value: '标准车型' },
        { prop: 'cdegModelTypeName', value: '车辆类型' },
        { prop: 'cdegStandardVolume', value: '标准方量m³', width: '100px' },
        { prop: 'carLengthRange', value: '长度范围' },
        {
            prop: 'flyWingFlag',
            value: '是否飞翼车',
            type: 'select',
            options: {
                Y: '是',
                N: '否'
            },
            width: '100px',
        },
        { prop: 'cdegInteriorLength', value: '内部长度(m)', width: '100px'},
        { prop: 'cdegInteriorWidth', value: '内部宽度(m)', width: '100px' },
        { prop: 'cdegInteriorHeight', value: '内部高度(m)', width: '100px' },
        { prop: 'cdegMaxVolume', value: '最大装载体积(m³)', width: '130px' },
        { prop: 'cdegMaxWeight', value: '最大装载重量(kg)', width: '130px' },
        { prop: 'axlesNum', value: '轴数(个)' },
    ],
    cbParams: [
        'cdegCode#length',
        'actualVechile#lengthNameCn',
        'cdegInteriorLength#insideLength',
        'cdegInteriorWidth#insideWidth',
        'cdegInteriorHeight#insideHeight',
        'cdegLengthKey#fuyouLengthKey',
        'cdegMaxVolume#lengthMaxVolume',
        'cdegMaxWeight#lengthMaxWeight',
        'cdegModelType#vehicleType',
        'axlesNum#axlesNum',
        'cdegStandardVolume#loadingVolume',
    ],
    configuration: {
        defaultProp: 'cdegCode,actualVechile,vehicleBigType,cdegModelTypeName,carLengthRange,cdegMaxVolume,cdegMaxWeight,axlesNum,cdegStandardVolume',
        defaultLabel: '车型代码,实际车型,标准车型,车辆类型,长度范围,最大装载体积(m³),最大装载重量(kg),轴数(个),标准方量m³',
        moduleCode: 'keydata-vehicle-modify-carType-mc',
        subjectType: 'keydata-vehicle-modify-carType'
    },
}

// 车辆常用司机高级组件配置信息
export const commonDriverParams = {
    name: '司机',
    value: 'commonDriver',
    unfold: true,
    advanceConfig: [
        { prop: 'driverName', value: '司机姓名' },
        { prop: 'driverCode', value: '司机编码' },
    ],
    tableConfig: [
        { prop: 'driverCode', value: '司机编码' },
        { prop: 'driverName', value: '司机姓名' },
        { prop: 'phoneNo', value: '手机' },
    ],
    advanceUrl: '',
    type: 'advance',
    prefix: SRM,
    cbParams: [
        'driverCode#commonDriverCode',
        'driverName#commonDriver',
        'phoneNo#commonDriverPhone',
        'delegateFileName#delegateFileName',
        'delegateNo#delegateNo',
        'delegateFileUrl#delegateFileUrl',
        'delegateEndTime#delegateEndTime',
    ],
}

// 表单数据
export const formData = {
    propertyNature: '', // 主体性质
    supplierCode: '', // 供应商编码
    vehicleType: '', // 车辆类型
    length: '',
    lengthNameCn: '', // 车型
    loadingVolume: '', // 装载方量
    lengthInteriorLength: '', // 车辆外径长度
    lengthInteriorWidth: '', // 车辆外径宽度
    lengthInteriorHeight: '', // 车辆外径高度
    insideLength: null, // 车辆内径长度
    insideWidth: null, // 车辆内径宽度
    insideHeight: null, // 车辆内径高度
    outlineSize: '', // 外廓尺寸
    lengthMaxWeight: '', // 核定载重量
    grossWeight: '', // 整备质量
    totalWeight: '', // 总质量
    fuyouLengthKey: '',
    lengthMaxVolume: '',
    licensePlateNo: '', // 车牌号
    carOwnerType: '', // 车辆归属
    isWithCar: '', //是否司机带车加入
    carOwner: '', // 车辆所有人
    carOwnerPhone: '', // 车辆所有人手机
    commonDriverCode: '', // 常用司机编码
    commonDriver: '', // 车辆常用司机
    commonDriverPhone: '', // 常用司机-手机
    deviceNo: '', // GPS设备号
    delegateNo: '',

    affiliatedFileNo: '', // 合作/租赁协议号
    affiliatedFileId: '', // 合作/租赁协议文件id
    affiliatedFileName: '', // 合作/租赁协议文件名称
    affiliatedFileUrl: '', // 合作/租赁协议文件url
    affiliatedStartTime: '', // 合作/租赁协议起始日期
    affiliatedEndTime: '', // 合作/租赁协议结束日期

    roadTransportNo: '', // 道路运输证号
    roadTransportFileId: '', // 道路运输证文件id
    roadTransportFileName: '', // 道路运输证文件名称
    roadTransportFileUrl: '', // 道路运输证文件url
    roadTransportStartTime: '', // 道路运输证起始日期
    roadTransportEndTime: '', // 道路运输证结束日期

    carDrivingFileId: '', // 行驶证正面文件id
    carDrivingFileName: '', // 行驶证正面文件名称
    carDrivingFileUrl: '', // 行驶证正面文件url
    carDrivingBottomFileId: '', // 行驶证背面文件id
    carDrivingBottomFileName: '', // 行驶证背面文件名称
    carDrivingBottomFileUrl: '', // 行驶证背面文件url
    carDrivingStartTime: '', // 行驶证起始日期
    carDrivingEndTime: '', // 行驶证结束日期

    photosVehicleFileId: '', // 车辆照片id
    photosVehicleFileName: '', // 车辆照片name
    photosVehicleFileUrl: '', // 车辆照片url

    trafficInsuranceFileId: '', // 交强险文件id
    trafficInsuranceFileName: '', // 交强险文件名称
    trafficInsuranceFileUrl: '', // 交强险文件url
    trafficInsuranceStartTime: '', // 交强险起始日期
    trafficInsuranceEndTime: '', // 交强险结束日期

    businessInsuranceFileId: '', // 商业保险文件id
    businessInsuranceFileName: '', // 商业保险文件名称
    businessInsuranceFileUrl: '', // 商业保险文件url
    businessInsuranceStartTime: '', // 商业保险起始日期
    businessInsuranceEndTime: '', // 商业保险结束日期

    mainVehicleType: '', // 车辆类型
    energyType: '', // 车辆能源类型
    licensePlateColor: '', // 车牌颜色
    mainUserCharacter: '', // 使用性质
    mainModel: '', // 品牌型号
    mainVin: '', // 车辆识别代码
    carDrivingAuthority: '', // 行驶证发证机关
    mainRegisterDate: '', // 注册日期（行驶证）
    mainIssueDate: '', // 发证日期（行驶证）
    capacity: '', // 核载人数
    inspectionRecord: '', // 检验记录

    trailerDrivingFileId: '', // 挂车行驶证正副页文件id
    trailerDrivingFileName: '', // 挂车行驶证正副页文件名称
    trailerDrivingFileUrl: '', // 挂车行驶证正副页文件url
    trailerLicensePlateNo: '', // 挂车车牌号

    trailerDrivingVerifyFileId: '', // 挂车行驶证年审页文件id
    trailerDrivingVerifyFileName: '', // 挂车行驶证年审页文件名称
    trailerDrivingVerifyFileUrl: '', // 挂车行驶证年审页文件url

    carAge: '', // 车龄
    vehicleEmissionsStandards: '', // 车辆排放标准
    axlesNum: '', // 轴数
    otherInformation: [], // 其他信息
    otherInformationExplain: '', // 其他信息补充说明
    trailerDrivingEndDate: '', // 超牌到期日期
}

// 校验核定载重量不能大于40000且大等于1
const checkLengthMaxWeight = (rule, value, callback) => {
    if (['', null, undefined].includes(value) || (/^[1-9]\d{0,4}$/.test(value) && Number(value) <= 40000)) {
        callback()
    } else {
        callback(new Error('请输入1-40000kg'))
    }
}
// 总质量校验不能为0
const checkTotalWeight = (rule, value, callback) => {
    if (value === '0') {
        callback(new Error('总质量不能为0'))
    } else {
        callback()
    }
}

const checkCarOwnerType = ctx => {
    return (rule, value, callback) => {
        const validName = ctx.isLegalPersonSupplier ? '供应商名称' : '负责人姓名'
        // 法人供应商，供应商名称与车辆所有人不一致
        const legalFlag = ctx.isLegalPersonSupplier && ctx.supplierName !== ctx.formData.carOwner
        // 个体供应商，负责人姓名与车辆所有人不一致
        const personFlag = !ctx.isLegalPersonSupplier && ctx.principalName !== ctx.formData.carOwner
        if (value && +value === +CAR_OWNER_TYPE.OWN && (legalFlag || personFlag)) {
            callback(new Error(`车辆所有人和${validName}不一致，不能选择“自有”类型`))
        } else {
            callback()
        }
    }
}
const checkLoadingVolume = ctx => {
    return (rule, value, callback) => {
        const valRegex = /^(?!-)(?:\d{1,18})(?:\.\d{1,8})?$/
        // 内径方量（内径长宽高相乘）
        // 内径方量-内径方量*2.5%≦装载方量≦内径方量+内径方量*2.5%
        const insideLength = ctx.formData.insideLength
        const insideWidth = ctx.formData.insideWidth
        const insideHeight = ctx.formData.insideHeight
        const innerDiameterVal = insideLength * insideWidth * insideHeight
        const maxSize = innerDiameterVal + innerDiameterVal * 0.025
        const maxNum = maxSize.toFixed(8)
        const minSize = innerDiameterVal - innerDiameterVal * 0.025
        const minNum = minSize.toFixed(8)
        const emptyList = [null, '']
        if (!valRegex.test(value)) {
            callback(new Error(`装载方量支持整数18位，小数点8位，不支持负数`))
        } else if (
            emptyList.includes(insideLength)
            || emptyList.includes(insideWidth)
            || emptyList.includes(insideHeight)
        ) {
            callback()
        } else if (!(value >= minNum - 0)  || !(value <= maxNum - 0)) {
            callback(new Error(`装载方量与内径方量之差必须在内径方量的±2.5%之内`))
        } else {
            callback()
        }
    }
}

const checkInnerSize = (ctx, largeProp, maxSize) => {
    return (rule, value, callback) => {
        const largeValue = ctx.formData[largeProp]
        const label = {
            lengthInteriorLength: '长',
            lengthInteriorWidth: '宽',
            lengthInteriorHeight: '高',
        }
        const _value = Number(value)
        if (value && !['', null, undefined].includes(largeValue) && !isNaN(Number(largeValue)) && _value > Number(largeValue)) {
            callback(new Error(`车辆内径${label[largeProp]}不可大于外径${label[largeProp]}，请重新输入`))
        } else if (value && maxSize && _value > maxSize) {
            callback(new Error(`车辆内径${label[largeProp]}不可大于${maxSize}米，请重新输入`))
        } else {
            callback()
        }
    }
}
// 当前日期是否大于交强险有效日期
const trafficInsuranceEffectiveDate = (rule, value, callback) => {
    if (!value) {
        callback()
    }
    const timestamp = new Date(value).getTime() // 获取的截止时间戳
    const time = new Date().getTime() // 获取的当前时间
    if (timestamp - time <= 0) {
        callback(new Error('交强险有效期必须大于当前时间'))
    } else {
        callback()
    }
}

// 当前日期是否大于商业保险有效日期
const businessInsuranceEffectiveDate = (rule, value, callback) => {
    if (!value) {
        callback()
    }
    const timestamp = new Date(value).getTime() // 获取的截止时间戳
    const time = new Date().getTime() // 获取的当前时间
    if (timestamp - time <= 0) {
        callback(new Error('商业保险有效期必须大于当前时间'))
    } else {
        callback()
    }
}

// 表单校验规则
export const formRules = ctx => {
    return {
        ...vehicleRules,
        // 交强险有效期
        trafficInsuranceEndTime: [
            { required: false, message: '请选择交强险有效期', trigger: ['blur', 'change'] },
            { validator: trafficInsuranceEffectiveDate, message: '交强险有效期必须大于当前时间', trigger: ['blur', 'change'] },
        ],
        // 商业保险有效期
        businessInsuranceEndTime: [
            { required: false, message: '请选择商业保险有效期', trigger: ['blur', 'change'] },
            { validator: businessInsuranceEffectiveDate, message: '商业保险有效期必须大于当前时间', trigger: ['blur', 'change'] },
        ],
        // 使用性质
        mainUserCharacter: [
            { required: true, message: '请输入使用性质', trigger: ['blur', 'change'] },
            { max: 60, message: '不能输入超过60个字符', trigger: ['blur', 'change'] }
        ],
        // 行驶证注册日期
        mainRegisterDate: [
            { required: true, message: '请选择行驶证注册日期', trigger: ['blur', 'change'] },
        ],
        // 行驶证发证日期
        mainIssueDate: [
            { required: true, message: '请选择行驶证发证日期', trigger: ['blur', 'change'] },
        ],
        // 车辆识别代码
        mainVin: [{ required: false, message: '请输入车辆识别代码', trigger: ['blur', 'change'] }],
        // 行驶证发证机关
        carDrivingAuthority: [
            { required: true, message: '请输入行驶证发证机关', trigger: ['blur', 'change'] },
        ],
        // 车辆类型
        mainVehicleType: [
            { required: true, message: '请选择车辆类型', trigger: ['blur', 'change'] },
        ],
        // 总质量(kg)
        totalWeight: [{ required: true, message: '请输入总质量', trigger: ['blur', 'change'] },
        { validator: checkTotalWeight, trigger: ['blur', 'change'] }],
        // 核定载重量
        lengthMaxWeight: [
            { required: true, message: '请输入核定载重量', trigger: ['blur', 'change'] },
            { validator: checkLengthMaxWeight, trigger: ['blur', 'change'] },
        ],
        carOwnerType: [
            { required: true, message: '请选择车辆归属', trigger: ['blur', 'change'] },
            { validator: checkCarOwnerType(ctx), trigger: ['blur', 'change'] },
        ],
        loadingVolume: [
            { required: true, message: '请输入装载方量', trigger: ['blur', 'change'] },
            { validator: checkLoadingVolume(ctx), trigger: ['blur', 'change'] },
        ],
        // 内径长度
        insideLength: [
            ...vehicleRules.insideLength,
            { validator: checkInnerSize(ctx, 'lengthInteriorLength'), trigger: ['blur', 'change'] },
        ],
        // 内径宽度
        insideWidth: [
            ...vehicleRules.insideWidth,
            { validator: checkInnerSize(ctx, 'lengthInteriorWidth', 3.2), trigger: ['blur', 'change'] },
        ],
        // 内径高度
        insideHeight: [
            ...vehicleRules.insideHeight,
            { validator: checkInnerSize(ctx, 'lengthInteriorHeight', 3.2), trigger: ['blur', 'change'] },
        ],
        // 超牌到期日期
        trailerDrivingEndDate: [
            { required: true, message: '请选择超牌到期日期', trigger: ['blur', 'change'] },
        ],
    }
}
